import { Stack } from '@mui/material';
import { EntityNames } from 'src/graphql/types';
import { StyledTab } from './search.styles';

export const TabsBar = ({
  selectedEntity,
  tabs,
  onEntityClick,
}: {
  tabs: { entity: EntityNames; label: string }[];
  selectedEntity: EntityNames;
  onEntityClick: (entity: EntityNames) => void;
}) => {
  return (
    <Stack
      flexDirection="row"
      alignItems="center"
      gap="0.5rem"
      flexWrap="wrap"
      padding="0.3rem"
      width="100%"
      data-testid="search-page-tabs"
    >
      {tabs.map((tab) => (
        <StyledTab
          key={tab.entity}
          variant="outlined"
          disabled={tab.entity === selectedEntity}
          onClick={() => onEntityClick(tab.entity)}
          data-testid={`search-page-tab-${tab.entity}`}
        >
          {tab.label}
        </StyledTab>
      ))}
    </Stack>
  );
};
